export default function elmntIO($el = null, callbackEnter = null, callbackExit = null) {
    if ( !('io' in $el.dataset) ) {
        $el.dataset.io = 'once';
    }

    // IntersectionObserver Options
    const ioOptions = {};

    ioOptions.threshold = 0.15;
    if ( 'ioThreshold' in $el.dataset && $el.dataset.ioThreshold ) {
        ioOptions.threshold = parseFloat($el.dataset.ioThreshold);
    }

    if ( 'ioMargin' in $el.dataset && $el.dataset.ioMargin ) {
        ioOptions.rootMargin = $el.dataset.ioMargin;
    }


    // custom options
    let ioViewportY = null;
    if ( 'ioViewportY' in $el.dataset ) {
        ioViewportY = ($el.dataset.ioViewportY) ? parseFloat($el.dataset.ioViewportY) : 50;
    }

    let ioYOffset = 50;
    if ( 'ioYOffset' in $el.dataset && $el.dataset.ioYOffset ) {
        ioYOffset = parseFloat($el.dataset.ioYOffset);
    }

    const customOptions = {
        viewportY: ioViewportY,
        yOffset: ioYOffset
    };


    // init io
    let io = new IntersectionObserver(handleIoEntry, ioOptions);
    io.observe($el);


    // do things
    function handleIoEntry(entries) {
        entries.forEach(entry => {
            if ( 'once' == entry.target.dataset.io ) {
                handleIoOnce(entry);
            } else {
                handleIo(entry);
            }
        });
    }

    function handleIoOnce(entry) {
        if ( entry.isIntersecting && 'true' != entry.target.dataset.ioVisible ) {
            entry.target.dataset.ioVisible = true;

            if ( typeof callbackEnter === 'function' ) {
                callbackEnter(entry);
            }
        }
    }

    function handleIo(entry) {
        if ( entry.isIntersecting ) {
            entry.target.dataset.ioVisible = true;

            if ( typeof callbackEnter === 'function' ) {
                callbackEnter(entry);
            }

            // Start scroll tracking if option is set
            if ( customOptions.viewportY && !entry.target._scrolling ) {
                entry.target._scrolling = true;
                window.addEventListener('scroll', handleIoScroll);

                // init elmnt-io-y before scroll if the page loads with el in view
                const elStyleStr = entry.target.getAttribute('style');
                if ( !elStyleStr || !elStyleStr.includes('--elmnt-io-y') ) {
                    handleIoScroll()
                }
            }
        } else {
            entry.target.dataset.ioVisible = false;

            if ( typeof callbackExit === 'function' ) {
                callbackExit(entry);
            }

            // Stop scroll tracking if option is set
            if ( customOptions.viewportY && entry.target._scrolling ) {
                entry.target._scrolling = false;
                window.removeEventListener('scroll', handleIoScroll);
            }
        }
    }

    const handleIoScroll = () => {
        const elRect = $el.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // if the element is in the viewport
        if ( elRect.top < viewportHeight && elRect.bottom >= 0 ) {
            const elYTarget = elRect.height * (customOptions.yOffset / 100);
            const viewportTarget = viewportHeight * (customOptions.viewportY / 100);
            const viewportTargetDistancePx = Math.round(elRect.top - viewportTarget + elYTarget);
            let viewportTargetDistancePercent = viewportTargetDistancePx / ((elRect.height + viewportHeight) / 2);
            viewportTargetDistancePercent = Number(viewportTargetDistancePercent.toFixed(3));

            // Preserve existing styles while updating --elmnt-io-y
            const currentStyle = $el.getAttribute('style') || '';
            const styleObj = {};
            
            // Parse existing styles into an object
            if (currentStyle) {
                currentStyle.split(';').forEach(declaration => {
                    if (declaration.trim()) {
                        const [property, value] = declaration.split(':').map(s => s.trim());
                        if (property && value) {
                            styleObj[property] = value;
                        }
                    }
                });
            }
            
            // Update only the --elmnt-io-y property
            styleObj['--elmnt-io-y'] = viewportTargetDistancePercent;
            
            // Rebuild the style string
            const newStyle = Object.entries(styleObj).map(([property, value]) => `${property}: ${value}`).join('; ');
            
            $el.setAttribute('style', newStyle);
        }
    }
}
